var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAttach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2C4.34315 2 3 3.34315 3 5V9C3 11.7614 5.23858 14 8 14C10.7614 14 13 11.7614 13 9V5C13 4.44772 13.4477 4 14 4C14.5523 4 15 4.44772 15 5V9C15 12.866 11.866 16 8 16C4.13401 16 1 12.866 1 9V5C1 2.23858 3.23858 0 6 0C8.76142 0 11 2.23858 11 5V9C11 10.6569 9.65685 12 8 12C6.34315 12 5 10.6569 5 9V5C5 4.44772 5.44772 4 6 4C6.55228 4 7 4.44772 7 5V9C7 9.55228 7.44772 10 8 10C8.55228 10 9 9.55228 9 9V5C9 3.34315 7.65685 2 6 2Z",
    fill: "currentColor"
  })));
}

export default SvgAttach;